var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('columns',[_c('column',{staticClass:"is-12"},[_c('u-header',{attrs:{"title":_vm.$t('_.product_options')}},[_vm._t("u-header-tags",null,{"slot":"tags"})],2),_vm._v(" "),_c('edit-product-options',{attrs:{"product-id":_vm.productId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }